import React from "react";

import HomeSystem from "../Components/Dashboard/Website/HomeSystem";



const HomeAll = () => {
  return (
    <div>
        <HomeSystem></HomeSystem>
        {/* <EventHeroSection></EventHeroSection> */}
        {/* <MessageClient></MessageClient> */}
        {/* <HomeWishList></HomeWishList>
        <HomeEvent></HomeEvent> */}
        {/* <EventHomeProducts></EventHomeProducts> */}
    </div>
  );
};

export default HomeAll;
